<ul class="inlineList menu">
  <li>
    <a dropdownToggle
       aria-controls="dropdown-button"
       (click)="setFocus()" (keydown.enter)="setFocus()"
       aria-label="Toggle Resource Center Menu"
       class="helpMenuToggle"
       tabindex="0"
    >
      <mat-icon class="headerHelpIcon">help_outline</mat-icon>
    </a>
    <!--
    <ul id="dropdown-button" *dropdownMenu class="menu is-dropdown-submenu dropdown-menu-right dropdown-pane" role="menu"
        (click)="stopPropagation($event)">
      <li>
        <div id="id-systemHelp" class="systemHelpPane">
          <div class="systemHelpPane-inner">
            <h4>Weave Help</h4>
            <p>Select an option to access resources or request help:</p>
            <ul class="helpTopicsUL">
              <li><a href="https://academiceffect.zendesk.com/hc/en-us" target="_blank" tabindex=0>Search Help
                Articles</a></li>
              <li><a target="_blank" href="https://academiceffect.zendesk.com/hc/en-us/requests/new"
                     tabindex=0>Submit a Ticket</a></li>
            </ul>
            <p *ngIf="false"><a href="#" tabindex=0>View all help topics</a></p>
            <div *ngIf="false" class="searchHelpBox">
              <input type="search" class="searchInput filterInput input-field" placeholder="Search help" tabindex=0>
            </div>
          </div>
        </div>
      </li>
    </ul>
    -->
  </li>
</ul>
